import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function PowerHub() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState({ activeIndex: 0 });
    const imgLocale = getImageLocal(locale, ['au', 'cn', 'za']);
    const powerHubData = {
        InverterCharger: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec2_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec3_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec3_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper1_spec4_title'),
                    text: t('presale.product.modals.power_hub_swiper1_spec4_text'),
                },
            ],
            img: [`power-hub1_${imgLocale}.webp`, `power-hub1_${imgLocale}.png`],
        },
        BatteryChargerWithMPPT: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper2_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper2_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper2_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper2_spec2_text'),
                },
            ],
            img: [`power-hub2_${imgLocale}.webp`, `power-hub2_${imgLocale}.png`],
        },
        MPPTSolarChargerController: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec2_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec3_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec3_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper3_spec4_title'),
                    text: t('presale.product.modals.power_hub_swiper3_spec4_text'),
                },
            ],
            img: [`power-hub3_${imgLocale}.webp`, `power-hub3_${imgLocale}.png`],
        },
        BuiltinWiFiAndBlueTooth: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper4_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper4_spec1_text'),
                },
            ],
            img: [`power-hub4_${imgLocale}.webp`, `power-hub4_${imgLocale}.png`],
        },
        ACOutlet: {
            specList: [
                {
                    title: t('presale.product.modals.power_hub_swiper5_spec1_title'),
                    text: t('presale.product.modals.power_hub_swiper5_spec1_text'),
                },
                {
                    title: t('presale.product.modals.power_hub_swiper5_spec2_title'),
                    text: t('presale.product.modals.power_hub_swiper5_spec2_text'),
                },
            ],
            img: [`power-hub5_${imgLocale}.webp`, `power-hub5_${imgLocale}.png`],
        },
    };

    const onSwiperSlideTo = (index: number) => {
        if (swiper && index !== active) {
            swiper?.slideTo(index);
        }
    };

    const renderSwiper = () => {
        const dom = [];
        for (const key in powerHubData) {
            const { specList, img } = powerHubData[key];
            dom.push(
                <SwiperSlide>
                    <div className="swiper-content">
                        <div className="spec-list">
                            {specList.map((item: any, index: number) => (
                                <div className="spec-item" key={index}>
                                    <div className="title">{item.title}</div>
                                    <div className="text">{item.text}</div>
                                </div>
                            ))}
                        </div>
                        <div className="product-img">
                            <EFPic name={[img[0], img[1]]} className="fullImgs" alt={key} />
                        </div>
                    </div>
                </SwiperSlide>,
            );
        }
        return dom;
    };

    return (
        <div className={`modal-power-hub ${css.PowerHubModal}`}>
            <div className="power-hub-box">
                <div className="left">
                    <div className="modal-title1">{t('presale.product.modals.power_hub_title1')}</div>
                    <div className="modal-title2">{t('presale.product.modals.power_hub_title2')}</div>
                </div>
                <div className="right">
                    <p className="swiper-title">
                        <span className={`text t ${active === 0 && 'active'}`} onClick={() => onSwiperSlideTo(0)}>
                            {t('presale.product.modals.power_hub_swiper1_title')}
                        </span>
                        <span className="s t" aria-hidden="true">
                            &nbsp;/&nbsp;
                        </span>
                        <span className={`text t ${active === 1 && 'active'}`} onClick={() => onSwiperSlideTo(1)}>
                            {t('presale.product.modals.power_hub_swiper2_title')}
                        </span>
                        <span className="s t" aria-hidden="true">
                            &nbsp; /&nbsp;
                        </span>
                        <span className={`text t ${active === 2 && 'active'}`} onClick={() => onSwiperSlideTo(2)}>
                            {t('presale.product.modals.power_hub_swiper3_title')}
                        </span>
                        <span className="s t" aria-hidden="true">
                            &nbsp; /&nbsp;
                        </span>
                        <span className={`text t ${active === 3 && 'active'}`} onClick={() => onSwiperSlideTo(3)}>
                            {t('presale.product.modals.power_hub_swiper4_title')}
                        </span>
                        <span className="s t" aria-hidden="true">
                            &nbsp; /&nbsp;
                        </span>
                        <span className={`text t ${active === 4 && 'active'}`} onClick={() => onSwiperSlideTo(4)}>
                            {t('presale.product.modals.power_hub_swiper5_title')}
                        </span>
                    </p>
                    <Swiper
                        className="power-hub-swiper"
                        modules={[Autoplay]}
                        slidesPerView={'auto'}
                        spaceBetween={30}
                        initialSlide={0}
                        preloadImages={false}
                        lazy={true}
                        centeredSlides={true}
                        grabCursor={true}
                        onSlideChange={(swiper: any) => setActive(swiper?.activeIndex % 5 || 0)}
                        onSwiper={(swiper: any) => setSwiper(swiper)}
                        pagination={{
                            clickable: true,
                        }}
                        loop
                    >
                        {renderSwiper()}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
